import { createMuiTheme } from "@material-ui/core/styles";
import Colors from "./Colors";
import { ThemeOptions } from "@material-ui/core/styles/createMuiTheme";

export const defaultThemeOptions: ThemeOptions = {
  palette: {
    primary: {
      main: Colors.colLightGrey
    },
    secondary: {
      main: Colors.colYellow
    },
    background: {
      paper: Colors.colLightGrey
    },
    text: {
      hint: Colors.hint
    }
  },
  typography: {
    fontFamily: "montserrat",
    useNextVariants: true
  },
  spacing: {
    unit: 10
  },
  zIndex: {
    modal: 9999,
    tooltip: 10000
  }
};

export const DefaultTheme = createMuiTheme(defaultThemeOptions);



// WEBPACK FOOTER //
// ./src/assets/MuiTheme.tsx